import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: "CurrentComponent",
  data() {
    return {};
  },
  setup() {
    return {
      input: ref('')
    };
  },
  provide() {
    return {
      staticValue: this.staticValue,
      // 直接返回值，不可响应
      staticObject: this.staticObject,
      // 返回一个对象，可响应
      getReactiveValue: () => this.staticValue // 返回一个对象的函数，可响应
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
});